import request from '@/static/js/request'

export function common_nav(param) {
    return request({
        url: 'common_nav',
        method: 'post',
        data:param
    })
}

export function common_slide(param) {
    return request({
        url: 'common_slide',
        method: 'post',
        data:param
    })
}

export function common_link(param) {
    return request({
        url: 'common_link',
        method: 'post',
        data:param
    })
}


export function common_config(param) {
    return request({
        url: 'common_config',
        method: 'post',
        data:param
    })
}


export function common_nav_product(param) {
    return request({
        url: 'common_nav_product',
        method: 'post',
        data:param
    })
}


export function common_download(param) {
    return request({
        url: 'common_download',
        method: 'post',
        data:param
    })
}


export function common_page(param) {
    return request({
        url: 'common_page',
        method: 'post',
        data:param
    })
}

export function common_match(param) {
    return request({
        url: 'common_match',
        method: 'post',
        data:param
    })
}


export function common_share(param) {
    return request({
        url: 'common_share',
        method: 'post',
        data:param
    })
}
